export const mockPlayInstallReferrer = {
  playInstallReferrer: ref(),
  appsflyerRequired: ref(false),
}
